import { render, staticRenderFns } from "./DevolucionDocumentos.vue?vue&type=template&id=59233113&scoped=true"
import script from "./DevolucionDocumentos.vue?vue&type=script&lang=js"
export * from "./DevolucionDocumentos.vue?vue&type=script&lang=js"
import style0 from "./DevolucionDocumentos.vue?vue&type=style&index=0&id=59233113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59233113",
  null
  
)

export default component.exports